module.exports = __webpack_public_path__ + "static/media/research_three.7a5164dd.psd";